export default "__VITE_ASSET__PyDTBjuc__"